export default __webpack_public_path__ + "static/media/video.7121e92b.svg";